/**
 * The three product partitions (ADR-0010). Every support table carries `product_id`, every /kb and
 * /api call names one with `?product=`, and nothing is combined across them.
 */
export type ProductId = "hr" | "accounting" | "jobs";

export interface ProductInfo {
  id: ProductId;
  name: string;
  /** Two letters for the console's product switch. */
  mark: string;
  /** The standfirst on the docs home page, under the workspace name. */
  tagline: string;
  /** Where the product itself lives, for the header's "open the app" link; null hides the link. */
  appUrl: string | null;
}

export const PRODUCTS: readonly [ProductInfo, ...ProductInfo[]] = [
  {
    id: "hr",
    name: "RigoHR",
    mark: "HR",
    tagline:
      "Everything you need to set up, configure, and run your people operations on RigoHR — from onboarding your first employee to bulk data imports and payroll.",
    appUrl: "https://app.rigohr.com",
  },
  {
    id: "accounting",
    name: "Rigo Accounting",
    mark: "AC",
    tagline: "Everything you need to set up and run your books on Rigo Accounting.",
    appUrl: null,
  },
  {
    id: "jobs",
    name: "RigoJobs",
    mark: "JB",
    tagline: "Everything you need to post jobs and hire on RigoJobs.",
    appUrl: null,
  },
];

export function isProductId(value: unknown): value is ProductId {
  return typeof value === "string" && PRODUCTS.some((p) => p.id === value);
}

export function productInfo(id: ProductId): ProductInfo {
  return PRODUCTS.find((p) => p.id === id) ?? PRODUCTS[0];
}
